module.exports = __webpack_public_path__ + "static/media/Two cuboids.0a957b6c.kra";